import React from 'react';
import Icon from '../Icon';
import { IconPosition, TextIconMarkup } from '../IconEnum';
import { is } from '../../../services';
import clsx from 'clsx';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
const TextIcon = ({ className, textClassName, name, content, position, markup, ...others }) => {
    const { styled } = useTrilogyContext();
    const isCorrectMarkup = (stringMarkup) => {
        if (stringMarkup in TextIconMarkup || Object.values(TextIconMarkup).includes(stringMarkup))
            return true;
    };
    const Tag = markup && isCorrectMarkup(markup) ? markup : 'span';
    if (position) {
        return (React.createElement("span", { className: hashClass(styled, clsx('icon-and-text', (position === IconPosition.UP || position === IconPosition.DOWN) && is('stacked'), className)) },
            (position === IconPosition.RIGHT || position === IconPosition.DOWN) &&
                content &&
                (content && typeof content.valueOf() === 'string' ? (React.createElement(Tag, { className: hashClass(styled, clsx(textClassName)) }, String(content))) : (content))
        // <Tag className={textClassName}>{content}</Tag>
        ,
            React.createElement(Icon, { name: name, className: className, ...others }),
            (position === IconPosition.UP || position === IconPosition.LEFT) &&
                content &&
                (content && typeof content.valueOf() === 'string' ? (React.createElement(Tag, { className: hashClass(styled, clsx(textClassName)) }, String(content))) : (content))
        // <Tag className={textClassName}>{content}</Tag>
        ));
    }
    return (React.createElement("span", { className: hashClass(styled, clsx('icon-and-text', className)) },
        React.createElement(Icon, { name: name, ...others }),
        content && typeof content.valueOf() === 'string' ? (React.createElement(Tag, { className: hashClass(styled, clsx(textClassName)) }, String(content))) : (content)));
};
export default TextIcon;
//# sourceMappingURL=TextIcon.js.map